import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import newsEventAPI from "../api/newsEventApi";

const NewsEventDetail = () => {
  const { id } = useParams();

  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchNewsDetail = async () => {
      setLoading(true);
      setError(false);
      setNews(null);

      try {
        const response = await newsEventAPI.news_events_api();

        if (!isMounted) return;

        const newsList =
          response?.code === 200 &&
          Array.isArray(response?.data?.["news-events"])
            ? response.data["news-events"]
            : [];

        const selectedNews = newsList.find(
          (item) => String(item.id) === String(id)
        );

        if (selectedNews) {
          setNews(selectedNews);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Error fetching news details:", err);

        if (isMounted) {
          setError(true);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchNewsDetail();

    return () => {
      isMounted = false;
    };
  }, [id]);

  const longDescription = news?.longDesc || news?.description || "";
  const desc = news?.desc || "";
  

  return (
    <div className="mrv-news-detail-root">
      <BreadCrumbBanner
        title={news?.title || news?.name || "News & Events"}
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      <section className="mrv-news-detail-section">
        <div className="container">

          {/* Back Navigation */}
          <div className="mrv-news-back">
            <Link to="/news-and-events">
             
              <span> &larr; Back to News & Events</span>
            </Link>
          </div>

          {/* Loading State */}
          {loading ? (
            <div className="mrv-news-state">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">
                  Loading...
                </span>
              </div>
              <p>Loading news details...</p>
            </div>
          ) : error || !news ? (

            /* Error State */
            <div className="mrv-news-state">
              <i className="fa-regular fa-newspaper"></i>
              <h3>News Not Found</h3>
              <p>
                This news or event could not be found.
              </p>

              <Link
                to="/news-and-events"
                className="mrv-news-back-btn"
              >
                <i className="fa-solid fa-arrow-left"></i>
                View All News
              </Link>
            </div>
          ) : (

            /* News Detail */
            <motion.article
              className="mrv-news-detail-card"
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >

              {/* News Header */}
              <header className="mrv-news-detail-header">

                {news.category && (
                  <span className="mrv-news-detail-category">
                    {news.category}
                  </span>
                )}

                <h1>
                  {news.title || news.name}
                </h1>

                <div className="mrv-news-detail-meta">

                  {news.date && (
                    <span>
                      <i className="fa-regular fa-calendar-days"></i>
                      {news.date}
                    </span>
                  )}

                  {news.category && (
                    <span>
                      <i className="fa-regular fa-folder-open"></i>
                      {news.category}
                    </span>
                  )}

                </div>
              </header>

              {/* Featured Image */}
              {news.image && (
                <div className="mrv-news-detail-image-wrap">
                  <img
                    src={news.image}
                    alt={
                      news.title ||
                      news.name ||
                      "News and event"
                    }
                    className="mrv-news-detail-image"
                  />
                </div>
              )}

              {/* Full News Content */}
              {longDescription && (
                <div className="mrv-news-detail-content">
                  <div
                    className="mrv-news-detail-description"
                    dangerouslySetInnerHTML={{
                      __html: longDescription,
                    }}
                  />
                </div>
              )}

               {desc && (
                <div className="mrv-news-detail">
                  <div
                    className="mrv-news-detail-description"
                    dangerouslySetInnerHTML={{
                      __html: desc,
                    }}
                  />
                </div> 
              )}

              {/* Footer */}
              <footer className="mrv-news-detail-footer">
                <Link
                  to="/news-and-events"
                  className="mrv-news-back-btn"
                >
               
                  Explore More News &rarr;
                </Link>
              </footer>

            </motion.article>
          )}

        </div>
      </section>
    </div>
  );
};

export default NewsEventDetail;